module.exports = __webpack_public_path__ + "static/media/bubble.2c946abd.png";